<template>
  <circle-image-button
    :image="image"
    :active="active"
    :title="title"
    :size="size"
    :btnClass="'primary ' + colorClass"
    @click="$emit('toggleGrayscaleMode')"/>
</template>

<script>
import circleImageButton from "../../controls/CircleImageButton";
export default {
  name: "grayscaleModeButton",
  components: { circleImageButton },
  props: {
    image: String,
    grayscaleMode: String,
    selectedGrayscaleMode: String,
    title: String,
    context: Object,
    size: { type: String, default: "small"}
  },
  computed: {
    active(){
      return this.selectedGrayscaleMode == this.grayscaleMode;
    }
  }
};
</script>